import Head from "next/head";

import HomePage, { HomepageProps } from "../components/HomePage";
import { FlashPCBPage } from "../models/page";
import React from "react";
import { HomePageGlobalStyle } from "../components/HomePage/HomePageStyles";
import { GetStaticProps } from "next";
import settings from "../constants/settings";
import { FlashPCBSettings } from "../utils/settings";

const TITLE_TEXT = "QUICK TURN PCB ASSEMBLY";
const DESCRIPTION_TEXT =
  "We run design rule checks on your board, automatically generate a bill of materials for you, and give you a final quote in minutes.";

const Home: FlashPCBPage<HomepageProps> = (props: HomepageProps) => {
  return (
    <>
      <Head>
        <title>FlashPCB</title>
        <meta name="description" content="Quick turn PCB assembly service" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <HomePage {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const response = await fetch(`${settings.api_url}/settings`);
  const flashPCBSettings = (await response.json()) as FlashPCBSettings;
  return {
    props: {
      flashPCBSettings,
      title: TITLE_TEXT,
      description: DESCRIPTION_TEXT,
    },
    revalidate: 60 * 60 * 24, // daily
  };
};

Home.GlobalStyle = HomePageGlobalStyle;

export default Home;
